import { BillingToggle } from "../../components/commerce/BillingToggle";
import { PlanCarousel } from "../../components/commerce/PlanCarousel";
import { beautyPlanPrices } from "../../constants/pricing";
import { beautyPlans } from "./beauty.constants";

type BeautyPlansProps = {
  isAnnual: boolean;
  onBillingChange: (isAnnual: boolean) => void;
};

export function BeautyPlans({ isAnnual, onBillingChange }: BeautyPlansProps) {
  return (
    <section className="planos-sec" id="planos">
      <div className="sec-kicker">Planos</div>
      <h2 className="sec-h">Transparente assim.</h2>
      <p className="sec-sub">Preço claro para começar e crescer quando sua operação pedir mais estrutura.</p>
      <BillingToggle isAnnual={isAnnual} onBillingChange={onBillingChange} />
      <PlanCarousel plans={beautyPlans} prices={beautyPlanPrices} isAnnual={isAnnual} />
      <div className="planos-note">
        <span>Evolução segura</span>
        <strong>Comece simples e cresça com continuidade.</strong>
        <small>Agenda, clientes e histórico permanecem na mesma operação quando o estabelecimento precisar ampliar a estrutura.</small>
      </div>
    </section>
  );
}
